<img src="../../../assets/images/login-close.svg" alt="" mat-dialog-close="" class="close-btn position-absolute">
<div class="px-3" style=" overflow: auto; max-height: 80vh;">
    <div class="row">
        <div class="col-12">
            <h4 class="fs-24 mb-3 fw-bold">{{isEditMode ? 'Update' : 'Add'}} {{modalHead}}</h4>
        </div>
        <div class="col-md-6" *ngIf="data?.selectedSubTabName == 'Category' && data?.currentTab == 'resources'">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Select Category *</mat-label>
                    <mat-select placeholder="Select Profile" [value]="'resource'">
                    <mat-option value="resource" selected>Resource</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-md-6" *ngIf="data?.currentTab == 'teams' || data?.currentTab == 'ourPartners'">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Name *</mat-label>
                    <input type="text" placeholder="Name" matInput [(ngModel)]="teamMemberName" [ngModelOptions]="{standalone: true}" appAlphabatesOnly>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-6" *ngIf="data?.currentTab == 'teams'">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Designation *</mat-label>
                    <input type="text" placeholder="Designation" matInput [(ngModel)]="teamMemberDesignation" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div>
        </div>
        <div class="col-12" *ngIf="data?.currentTab == 'teams' || data?.currentTab == 'ourPartners'">
            <div class="mb-3">
                <mat-form-field appearance="outline" class="example-full-width w-100" >
                    <mat-label>About {{data?.currentTab == 'ourPartners' ? '*' : '' }}</mat-label>
                    <textarea matInput placeholder="About" rows="4" [(ngModel)]="teamMemberAbout"></textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="col-md-6" *ngIf="!tabsAllow.includes(data?.currentTab) && (data?.selectedSubTabName != 'Category')">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>{{data?.currentTab == 'resources' ? selectedSubTabName == 'Sub Category ' ? 'Select Category *' : 'Select Sub Category *' : 'Select Category *'}}</mat-label>
                    <mat-select [(ngModel)]="selectedSection" >
                        <mat-option [value]="item?.sectionId || item?.id" *ngFor="let item of sectionDropdown">
                            {{item['section.name'] || item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-12" *ngIf="data?.currentTab == 'contactUsEmail'">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Display Email *</mat-label>
                    <input type="email" placeholder="pal@idhtrade.org" matInput [(ngModel)]="contactEmailLink" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-6" *ngIf="!isEditMode && data?.currentTab == 'contactUsEmail' && sectionDropdown?.length">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Section *</mat-label>
                    <mat-select [(ngModel)]="selectedSection">
                        <mat-option [value]="item?.id || item?.sectionId" *ngFor="let item of sectionDropdown">
                            {{item['section.name'] || item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-6" *ngIf="!isEditMode && data?.currentTab == 'privacyStatement' && sectionDropdown?.length">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Section *</mat-label>
                    <mat-select [(ngModel)]="selectedSection">
                        <mat-option [value]="item?.id || item?.sectionId" *ngFor="let item of sectionDropdown">
                            {{item['section.name'] || item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-6" *ngIf="!isEditMode && data?.currentTab == 'prismIntro' && sectionDropdown?.length">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Section *</mat-label>
                    <mat-select [(ngModel)]="selectedSection">
                        <mat-option [value]="item?.id || item?.sectionId" *ngFor="let item of sectionDropdown">
                            {{item['section.name'] || item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-6" *ngIf="data?.currentTab != 'glossary' && data?.currentTab != 'contactUs' && data?.currentTab != 'contactUsEmail' && data?.currentTab != 'privacyStatement' && data?.currentTab != 'prismIntro' && data?.currentTab != 'teams' && data?.currentTab != 'ourPartners'">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Title *</mat-label>
                    <input type="text" placeholder="Title" matInput [(ngModel)]="titleData" [ngModelOptions]="{standalone: true}" appAlphabatesOnly>
                </mat-form-field>
            </div>
        </div>

        <div class="col-md-12" *ngIf="data?.currentTab == 'glossary'">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>Term *</mat-label>
                    <input type="text" placeholder="Term" matInput [(ngModel)]="termData" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <span style="color: red;" *ngIf="termEmpty">*Term is required</span>
            </div>

        </div>
        <div class="col-md-12" *ngIf="data?.currentTab == 'impactStories' || data?.currentTab == 'aboutUs'">
            <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                  <mat-label>Video URL </mat-label>
                  <input type="text" placeholder="https://example.com/xyz/" matInput [(ngModel)]="videoUrl" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>
        </div>
        <div class="col-12" *ngIf=" isEditMode && (data?.currentTab == 'ourPartners' || data?.currentTab == 'impactStories' || data?.currentTab == 'teams')">
              <div class="position-relative">
                <mat-form-field appearance="outline" class="example-full-width w-100">
                  <mat-label>Rank *</mat-label>
                  <input class="removeNumberArrow" type="number" placeholder="Rank" matInput [(ngModel)]="rank" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)">
                  <span  *ngIf="isValidRank(rank)" style="color: red;">* Rank Field does not allow Zero(0) && Negative(-1,-2,...)</span>
                </mat-form-field>
              </div>
        </div>
        <div class="col-12" *ngIf="data?.currentTab == 'homepage' || data?.currentTab == 'glossary' || data?.currentTab == 'impactStories' || data?.currentTab == 'aboutUs' || data?.currentTab == 'privacyStatement' || data?.currentTab == 'prismIntro'">
            <div class="mb-3" >
               <h6 class="fs-16 fw-bold mb-3">{{ data?.currentTab == 'privacyStatement' ? 'Privacy Statement *' : (data?.currentTab == 'prismIntro' ? 'Page Content *' : 'Description ' + (['impactStories','glossary'].includes(data?.currentTab) ? '*' : '')) }}</h6>
               <p class="cms-image-width-hint mb-3" role="note">
                   <strong>Use 900 pixels width for best results.</strong>
                   <br />
                   <strong>Max Image Upload Size is 1 MB images for best performance.</strong>
               </p>
               <div #editorElem class="custom-font-size" style="height: 25vh;"></div>
          </div>
        </div>
        <div class="col-12" *ngIf="data?.currentTab == 'prismIntro'">
            <div class="mb-3">
                <h6 class="fs-16 fw-bold mb-2">Source HTML (optional)</h6>
                <p class="text-muted small mb-2">Paste full page HTML here to override the rich text editor. Use for tables and custom layout.</p>
                <textarea class="form-control font-monospace" rows="8" [(ngModel)]="sourceHtml" [ngModelOptions]="{standalone: true}" placeholder="&lt;div class=&quot;row&quot;&gt;..."></textarea>
            </div>
        </div>
        <div class="col-12">
        <ng-container *ngIf="(data?.currentTab != 'glossary' && data?.currentTab != 'contactUs' && data?.currentTab != 'contactUsEmail' && data?.currentTab != 'privacyStatement' && data?.currentTab != 'prismIntro') && (data?.selectedSubTabName != 'Sub Category')">
            <h6 class="fs-16 fw-bold mb-3">Featured image {{(['ourPartners','impactStories','resources','teams'].includes(data?.currentTab) || ['Sub Category','impactStories'].includes(data?.selectedSubTabName)) ? '*' : '' }}</h6>
            <p *ngIf="data?.currentTab == 'teams'" class="cms-image-width-hint mb-3" role="note">
                <strong>Ideal image size: 800 × 600 px (4:3 aspect ratio).</strong> Images with a different aspect ratio may be cropped on the homepage.
            </p>
            <div class="receiptCard mt-2 mt-md-3">
                <form action="" [formGroup]="libraryForm">

                    <div class="uploadContainer my-2" appDnd (fileDropped)="onFileDropped($event)">
                        <div class="box">
                            <input type="file" accept="image/png, image/gif, image/jpeg" #fileDropRef
                                id="fileDropRef" formControlName='files'
                                (change)="fileBrowseHandler($event)"
                                />
                                <img src="../../../../assets/images/Image-upload.png" class="img-fluid mb-3" style="max-width: 200px;" alt="">
                        <div style="font-size:14px; font-weight:500; margin-top:10px;">Upload Receipt/Screenshot
                            </div>
                            <div style="font-size: 12px;">
                                <label for="fileDropRef"
                                    style="color:#503794; font-weight:500; cursor:pointer;">Browse</label>
                                <span style="margin-left:4px; font-weight:500;">or Drag & Drop</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p class="uploadFileInfo"><i>{{fileUploadInfo}}</i></p>
                    </div><br>
                    <div class="files-list mx-auto">
                        <div class="single-file" *ngFor="let file of files; let i = index">
                            <div class="file-icon" style="width: 50px">
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58 58"
                                    style="enable-background:new 0 0 58 58;" xml:space="preserve">
                                    <polygon style="fill:#EDEADA;" points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
                                    <g>
                                        <path style="fill:#CEC9AE;"
                                            d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
                                        <path style="fill:#CEC9AE;"
                                            d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
                                        <path style="fill:#CEC9AE;"
                                            d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
                                        <path style="fill:#CEC9AE;"
                                            d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
                                        <path style="fill:#CEC9AE;"
                                            d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
                                    </g>
                                    <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
                                </svg>
                            </div>
                            <div class="info">
                                <a style="text-decoration: none;" [href]="imgURL"
                                    target="_blank" class="name">
                                    {{ file?.name ? file?.name : file?.file_Path}}
                                </a>
                                <div *ngIf="file?.progress">
                                    <app-upload-progress [progress]="file?.progress"></app-upload-progress>
                                </div>
                            </div>

                            <div class="delete" [matTooltip]="'Delete'" (click)="deleteFile(i)">
                                  <img src="../../../../assets/images/delete-bin.svg" alt="" style="cursor: pointer;">
                            </div>

                        </div>

                    </div>
                    <div *ngIf="isEditMode && !clickImage" class="d-flex">
                        <img *ngIf="imgURL?.length" class="prefillImage" [src]="imgURL.includes('pdf') ? '../../../../assets/icons/pdfIcon.svg' : imgURL.includes('.docx') ? '../../../../assets/icons/msWordIcon.svg' : imgURL" alt="" (click)="openDocument()">
                        <div *ngIf="imgURL?.length" [matTooltip]="'Delete'" class="delete ms-2" (click)="deleteFile(0)">
                            <img src="../../../../assets/images/delete-bin.svg" alt="" style="cursor: pointer;">
                      </div>
                    </div>
                </form>
            </div>
        </ng-container>
        <div class="text-end">
            <button class="btn rounded-pill me-3 border bg-white" (click)="closeDialog()">Cancel</button>
            <button class="btn rounded-pill upload-btn text-white" (click)="submitModalData()" [disabled]="isDisable()">{{submitButtonName}}</button>
        </div>
        </div>
    </div>
</div>


